export const getCurrentRestaurantUuid = () => {

    return localStorage.getItem('restaurant_uuid');

};

export default getCurrentRestaurantUuid 
